// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error {
  margin: 10% 15%;
}

@media only screen and (max-width: 1024px) {
  .error {
    padding-top: 25px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/system-error/system-error.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AACA;EACI;IACJ,iBAAA;EAEE;AACF","sourcesContent":[".error {\n    margin: 10% 15%;\n}\n@media only screen and (max-width: 1024px) {\n    .error {\npadding-top: 25px;}}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
